import { DateTime } from 'luxon';
import * as r from 'ramda';

export default ({ timer, config, now, serviceFactory }) => {

  const interval = config.datesService.interval || 60000;
  now = now || (() => DateTime.utc());

  var last;
  return serviceFactory({
    name: 'dates-service',
    subscribe: (update) => timer.periodic('dates-service', interval, () => {

      const today = now().endOf('day');
      const friday = today.plus({ days: (today.weekday <= 5 ? 5 - today.weekday : 12 - today.weekday) });

      const lastFridayOfMonth = (start, n) => {
        var next = start;
        while ((next.month >= start.month ? next.month : next.month + 12) - start.month <= n) {
          next = next.plus({ weeks: 1 })
        }
        return next.minus({ weeks: 1 });
      }

      if (!last || !friday.equals(last)) {
        last = friday;
        var dates = [
          ...r.times(n => friday.minus({ weeks: 6 - n }), 6),
          friday,
          ...r.times(n => friday.plus({ weeks: n + 1 }), 5),
          ...r.times(n => lastFridayOfMonth(friday.plus({ weeks: 6 }), n), 6)
        ];

        update({
          dates,
          next: friday
        });
      }
    })

  })
}



// WEBPACK FOOTER //
// ./src/api/dates-service.js